export default function Reviews() {
  const reviews = [
    {
      name: '山田さん（32歳・会社員）',
      rating: 5,
      title: 'ECモールでザクザク貯まる！',
      comment: 'ECモールでよく買い物をするので、ポイントがどんどん貯まります。SPUで倍率を上げれば、実質10%以上の還元率になることも。貯まったポイントで日用品を買えるので、家計が本当に助かっています。',
      date: '2025年1月',
    },
    {
      name: '佐藤さん（26歳・主婦）',
      rating: 5,
      title: '年会費無料なのに1%還元',
      comment: 'スーパーやコンビニでも1%還元されるので、メインカードとして使っています。スマホ決済と連携すれば、ポイント二重取りもできて最高です。入会特典の5,000ポイントもすぐにもらえました。',
      date: '2024年12月',
    },
    {
      name: '田中さん（29歳・フリーランス）',
      rating: 4,
      title: 'ポイントの使い道が豊富',
      comment: 'ポイントはECモールだけでなく、スマホ決済で街のお店でも使えるのが便利。マクドナルドやファミマでもポイント払いできます。ただ、メールが多いのが少し気になります。',
      date: '2024年11月',
    },
    {
      name: '鈴木さん（35歳・会社員）',
      rating: 5,
      title: '経済圏で生活が変わった',
      comment: 'カード、モバイルサービス、銀行を使っていて、毎月数千ポイント貯まります。年間で10万ポイント以上貯まるので、実質的な節約効果は大きいです。もう手放せません。',
      date: '2024年10月',
    },
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-[#F8F9FA] to-[#FFF0F0]">
      <div className="max-w-5xl mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-[#BF0000] mb-3 text-center">
          利用者の口コミ・評判
        </h2>
        <p className="text-gray-600 text-center mb-12">実際に使っている人のリアルな声</p>

        <div className="grid md:grid-cols-2 gap-6">
          {reviews.map((review, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow">
              <div className="flex items-center justify-between mb-3">
                <div>
                  <p className="text-[#BF0000] font-bold text-sm">{review.name}</p>
                  <p className="text-gray-500 text-xs">{review.date}</p>
                </div>
                <div className="flex gap-1">
                  {[...Array(5)].map((_, i) => (
                    <i
                      key={i}
                      className={`ri-star-${i < review.rating ? 'fill' : 'line'} text-[#FF9900] text-sm`}
                    ></i>
                  ))}
                </div>
              </div>
              <h4 className="text-[#BF0000] font-bold text-base mb-2">{review.title}</h4>
              <p className="text-gray-700 text-sm leading-relaxed">{review.comment}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 text-center">
          <div className="inline-flex items-center gap-2 bg-white rounded-full px-6 py-3 shadow-md">
            <div className="flex gap-1">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-[#FF9900] text-lg"></i>
              ))}
            </div>
            <span className="text-[#BF0000] font-bold text-lg">4.7</span>
            <span className="text-gray-600 text-sm">/ 5.0（2,856件のレビュー）</span>
          </div>
        </div>
      </div>
    </section>
  );
}
